import React, { useState } from "react";
import { SideMenu } from "./../../components";
import { Button } from "@mui/material";
import "./settings.css";
import { BiChevronRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
let Setting = () => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-data-view-container">
        <div>
          <Button
            className="setting-list-button"
            onClick={() => navigate("/settings/invoice")}
          >
            <p className="setting-list-button-text">Invoice Settings</p>
            <BiChevronRight color="#A6A6A6" size={25} />
          </Button>
          <Button
            className="setting-list-button"
            onClick={() => navigate("/settings/tc")}
          >
            <p className="setting-list-button-text">T&C </p>
            <BiChevronRight color="#A6A6A6" size={25} />
          </Button>
          <Button className="setting-list-button">
            <p className="setting-list-button-text">Upload Document </p>
            <BiChevronRight color="#A6A6A6" size={25} />
          </Button>
        </div>
      </div>
    </SideMenu>
  );
};
export default Setting;
